import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QrCode, Share2, UtensilsCrossed, Plus, Sparkles, ArrowRight, ScanLine } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";

export default function DashboardHome() {
  const navigate = useNavigate();
  const { user, company } = useAuth();
  const [counts, setCounts] = useState({ qr: 0, pages: 0, menus: 0, scans: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [qr, pages, menus] = await Promise.all([api.qrList(), api.pageList(), api.menuList()]);
        const scans = qr.data.reduce((a, b) => a + (b.scans || 0), 0);
        setCounts({ qr: qr.data.length, pages: pages.data.length, menus: menus.data.length, scans });
      } catch {}
    })();
  }, []);

  const cards = [
    { label: "QR Code", value: counts.qr, icon: QrCode, to: "/app/qr" },
    { label: "Pagine", value: counts.pages, icon: Share2, to: "/app/pagine" },
    { label: "Menù", value: counts.menus, icon: UtensilsCrossed, to: "/app/menu" },
    { label: "Scansioni totali", value: counts.scans, icon: ScanLine, to: "/app/qr" },
  ];

  const actions = [
    { title: "Importa un menù con l'AI", desc: "Carica un PDF o una foto: l'AI struttura tutto.", icon: Sparkles, to: "/app/menu", primary: true },
    { title: "Crea un QR Code", desc: "Statico o dinamico, personalizzato.", icon: QrCode, to: "/app/qr" },
    { title: "Crea una pagina", desc: "Link, contatti e menù in un'unica pagina.", icon: Share2, to: "/app/pagine" },
  ];

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="font-display text-2xl md:text-3xl font-extrabold">Ciao, {user?.name?.split(" ")[0]} 👋</h1>
          <p className="text-muted-foreground mt-1">{company?.name} · Piano {company?.plan}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <button key={c.label} onClick={() => navigate(c.to)} className="text-left rounded-2xl border border-border bg-white p-5 card-shadow hover-lift">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/8 text-primary mb-3"><Icon className="h-5 w-5" /></span>
              <p className="font-display text-2xl font-extrabold">{c.value}</p>
              <p className="text-sm text-muted-foreground">{c.label}</p>
            </button>
          );
        })}
      </div>

      <h2 className="font-display text-lg font-bold mb-3">Inizia da qui</h2>
      <div className="grid md:grid-cols-3 gap-4">
        {actions.map((a) => {
          const Icon = a.icon;
          return (
            <button key={a.title} onClick={() => navigate(a.to)}
              className={`text-left rounded-2xl p-6 hover-lift border ${a.primary ? "btn-grad text-white border-transparent" : "bg-white border-border"}`}>
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl mb-4 ${a.primary ? "bg-white/20" : "bg-primary/8 text-primary"}`}><Icon className="h-5 w-5" /></span>
              <h3 className="font-display font-bold flex items-center gap-1">{a.title} <ArrowRight className="h-4 w-4" /></h3>
              <p className={`text-sm mt-1 ${a.primary ? "text-white/80" : "text-muted-foreground"}`}>{a.desc}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
